import { t } from '@/translations/i18n';
import { DEFAULT_TEXTBOX_TEXT } from '@/domain/textbox/defaultTextboxText';
import { ETextAlign } from '@/domain/textbox/ETextAlign';
import { TextboxField } from '@/domain/textbox/TextboxField';
import type { ITemplate } from '@/domain/template/ITemplate';
import type { ITemplateConfiguration } from '@/domain/template/ITemplateConfiguration';

function getEmptyTemplate(noFields = false): ITemplate {
    return {
        name: t('custom_template_name'),
        thumbnailUrl: '/images/custom_template_thumbnail.jpg',
        configuration: noFields ? { fields: [] } : getEmptyTemplateConfiguration(),
    };
}

function getEmptyTemplateConfiguration(): ITemplateConfiguration {
    return {
        fields: [getEmptyTextboxField()],
    };
}

function getEmptyTextboxField(): TextboxField {
    return new TextboxField({
        characterSpacing: 0,
        color: '#000000',
        fontFamily: 'AmbroiseStd-Regular',
        fontSize: 25,
        lineSpacing: 0,
        placeholder: DEFAULT_TEXTBOX_TEXT,
        side: 'recto',
        size: { width: 500, height: 0 },
        textAlign: ETextAlign.Center,
    });
}

export { getEmptyTemplate, getEmptyTemplateConfiguration };
